/**
 * Ruta `/solicitud/{ref}` (US3, T039): seguimiento de la solicitud de re-vinculación.
 *
 * La referencia es opaca y no se muestra en pantalla: solo viaja en la URL para consultar
 * `GET /rebind-requests/{ref}`. Al reclamar la vinculación (`claim`) ya hay cookie de sesión, así
 * que se vuelve a Inicio, que decide qué mostrar.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RebindStatusScreen } from '../features/access/rebind-status';

export function RebindStatusRoute() {
  const { ref } = Route.useParams();
  const navigate = useNavigate();

  return (
    <RebindStatusScreen
      requestRef={ref}
      onClaimed={() => void navigate({ to: '/', replace: true })}
      onBack={() => void navigate({ to: '/dispositivo-no-registrado' })}
      onRequestAgain={() => void navigate({ to: '/dispositivo-no-registrado', replace: true })}
    />
  );
}

export const Route = createFileRoute('/solicitud/$ref')({
  component: RebindStatusRoute,
});
